var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"last-saved-timestamp"},[(_vm.saving)?_c('i',{staticClass:"loading fa fa-spinner fa-pulse"}):[_vm._v(" Last saved: "+_vm._s(_vm.short ? _vm.format_datetime_short(_vm.last_modified) : _vm.format_datetime(_vm.last_modified))+" ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }